import { CSSProperties, HTMLProps } from 'react';

import { ProgressCircle } from '@spotify-internal/encore-web';

import styles from './LoadingOverlay.module.css';

type LoadingOverlayProps = HTMLProps<HTMLDivElement> & {
  loading?: boolean;
  height?: number;
};

export const LoadingOverlay = ({
  loading = false,
  height,
  ...props
}: LoadingOverlayProps) => (
  <div className={styles.backdropContainer} {...props}>
    {loading && (
      <div className={styles.backdrop}>
        <ProgressCircle
          aria-label="Loading"
          semanticColor="textBrightAccent"
          className={styles.spinner}
          style={
            height
              ? ({ bottom: `${height / 2}px` } as CSSProperties)
              : undefined
          }
        />
      </div>
    )}
  </div>
);
